// extracted by mini-css-extract-plugin
export var header = "SecretComponents-module--header--8av4b";
export var link = "SecretComponents-module--link--QidSO";